/* PLTÉ Maison · Find PLTÉ: pin ↔ kaartje, nachtlaag na interactie, You are here (?at=<handle>). Zonder JS: ankerlijst.
   PLTE.* pas in de handler opzoeken (defer in <main>). init() per sectie, ook na shopify:section:load; calm volgt plte:motion. */
(function () {
  'use strict';
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var calm = reduce || document.documentElement.hasAttribute('data-motion-off');
  document.addEventListener('plte:motion', function (e) { calm = reduce || !(e.detail && e.detail.on); });

  function init(sec) {
    if (!sec || sec.dataset.mapReady) return;
    sec.dataset.mapReady = '1';
    var atlas = sec.querySelector('.atlas');
    var pins = [].slice.call(sec.querySelectorAll('a.pin[id^="pin-"]'));
    var lit = false, activeCard = null, litPin = null, hotPin = null;

    function byId(prefix, h) { return document.getElementById(prefix + h); }
    function scrollTo(el) {
      if (window.PLTE && typeof PLTE.scrollTo === 'function') { PLTE.scrollTo(el, { offset: -120 }); }
      else { el.scrollIntoView({ block: 'center', behavior: calm ? 'auto' : 'smooth' }); }
    }
    function light() { /* één keer, nooit op scrollpositie, niet onder reduced motion of Motion · off */
      if (lit || calm || !atlas || !atlas.hasAttribute('data-lit')) return;
      lit = true; atlas.classList.add('is-lit');
    }
    function hot(h) {
      if (hotPin) hotPin.classList.remove('is-hot');
      hotPin = h ? byId('pin-', h) : null;
      if (hotPin) hotPin.classList.add('is-hot');
    }
    function activate(h) {
      var card = byId('stockist-', h), pin = byId('pin-', h);
      if (!card) return null;
      if (activeCard) activeCard.classList.remove('is-active');
      if (litPin) litPin.classList.remove('is-lit-pin');
      activeCard = card; card.classList.add('is-active');
      litPin = pin; if (pin) pin.classList.add('is-lit-pin');
      return card;
    }

    /* pin-klik: zachte scroll naar het kaartje, anker in de URL */
    sec.addEventListener('click', function (e) {
      var a = e.target.closest('a.pin[id^="pin-"]');
      if (!a) return;
      var h = a.id.slice(4), card = activate(h);
      if (!card) return;
      e.preventDefault();
      light();
      scrollTo(card);
      try { history.replaceState(null, '', '#stockist-' + h); } catch (_) {}
    });
    /* hover/focus op een pin of hover op een kaartje: licht aan, pin groeit; een vinger op de lijst (touch-scroll) telt niet */
    sec.addEventListener('pointerover', function (e) {
      var p = e.target.closest('a.pin'), c = p ? null : e.target.closest('.stockist');
      if (c && e.pointerType === 'touch') return;
      if (p) { light(); hot(p.id.slice(4)); }
      else if (c) { light(); hot(c.getAttribute('data-handle')); }
    }, { passive: true });
    sec.addEventListener('pointerout', function (e) {
      var c = e.target.closest('.stockist, a.pin');
      if (c && !(e.relatedTarget && c.contains(e.relatedTarget))) hot(null);
    }, { passive: true });
    sec.addEventListener('focusin', function (e) {
      var p = e.target.closest('a.pin');
      if (p) { light(); hot(p.id.slice(4)); }
    });
    sec.addEventListener('focusout', function (e) {
      if (e.target.closest && e.target.closest('a.pin')) hot(null);
    });

    /* één pin ademt tegelijk, elke 6 s de volgende; stil buiten beeld, bij verborgen tab en onder reduced motion */
    if (!calm && pins.length && atlas) {
      var idx = 0, cur = null, inView = true;
      var breathe = function () {
        if (document.hidden || !inView || !sec.isConnected) return;
        if (cur) cur.classList.remove('is-breathing');
        cur = pins[idx++ % pins.length];
        cur.classList.add('is-breathing');
      };
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { inView = es[0].isIntersecting; }, { threshold: 0.1 }).observe(atlas);
      }
      breathe();
      setInterval(breathe, 6000);
    }

    /* You are here: ?at=<handle> alleen na whitelist, getElementById, textContent */
    var at = null;
    try { at = new URLSearchParams(location.search).get('at'); } catch (_) {}
    if (at && /^[a-z0-9-]{1,64}$/.test(at)) {
      var card = activate(at);
      if (card) {
        light();
        if (!card.querySelector('.stockist__here')) {
          var here = document.createElement('p');
          here.className = 'stockist__here';
          here.textContent = sec.getAttribute('data-here') || '';
          card.insertBefore(here, card.firstChild);
        }
        var done = false;
        var go = function () { if (done) return; done = true; scrollTo(card); };
        if (window.PLTE && typeof PLTE.scrollTo === 'function') requestAnimationFrame(go);
        else { document.addEventListener('plte:ready', function () { requestAnimationFrame(go); }, { once: true }); setTimeout(go, 1200); }
      }
    }
  }

  init(document.querySelector('[data-studio-map]'));
  /* theme editor: sectie opnieuw gerenderd -> opnieuw binden (de oude ademtimer stopt zelf via isConnected) */
  document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-studio-map]')); });
})();
